import { Tag } from 'antd';
import 'bootstrap-icons/font/bootstrap-icons.min.css';
import React from 'react';

import styles from './filter-tag.style';

/**
 * Props para el componente FilterTag.
 */
type FilterTagProps = {
  /**
   * El contenido que se mostrará dentro de la etiqueta.
   */
  label: React.ReactNode;
  /**
   * Una función de devolución de llamada que se ejecutará cuando se cierre la etiqueta.
   * Proporcionar esta función hará que la etiqueta se pueda cerrar.
   */
  onClose?: () => void;
};

/**
 * Un componente que muestra una etiqueta que se puede cerrar, que se usa normalmente para filtros.
 * Es un contenedor estilizado alrededor del componente Tag de Ant Design.
 *
 * @param {FilterTagProps} props - Las props para el componente FilterTag.
 *
 * @returns {JSX.Element} El componente FilterTag renderizado.
 */
const FilterTag = ({ label, onClose }: FilterTagProps) => (
  <Tag
    closeIcon={<i className='bi bi-x-lg' style={styles.filter__close}></i>}
    closable={!!onClose}
    onClose={onClose}
    style={styles.filter}>
    {label}
  </Tag>
);

export default FilterTag;
